module.exports = __webpack_public_path__ + "media/images/icon/payment/visa-card-cdcd1512ec4bc71e7b4836a28b1aeb82.svg";